<div class="approval-rule-form">
  <div class="p-5">
    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="mt-4 inline"
          >{{ !approvalRuleId ? 'Create' : 'Update' }} Approval Rule</h3
        >
      </div>
      <div class="align-self-center">
        <button
          *ngIf="!isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          [routerLink]="['settings/approval-rule-settings']"
        >
          <lum-ui-icon
            icon="chevron-left-circle"
            [width]="24"
            [height]="24"
            color="#5563d6"
          ></lum-ui-icon>
          Go Back To Approval Rules
        </button>

        <button
          *ngIf="isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          (click)="dialogRef.close()"
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>
    <mat-divider class="my-2"></mat-divider>
  </div>

  <mat-card class="lum-mat-card" *ngIf="!isDialog">
    <mat-card-content>
      <ng-container *ngTemplateOutlet="approvalRuleForm"></ng-container>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="isDialog">
    <ng-container *ngTemplateOutlet="approvalRuleForm"></ng-container>
  </ng-container>
</div>

<ng-template #approvalRuleForm>
  <form [formGroup]="form">
    <div class="p-5">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Name</label>
            <input
              formControlName="name"
              type="text"
              required="true"
              class="lum-input"
            />
          </div>
          <mat-error *ngIf="form.get('name')?.invalid">
            {{ form.get('name') | validateField }}
          </mat-error>

          <div class="form-group">
            <label>Model</label>
            <mat-select
              class="lum-select"
              formControlName="model"
              (selectionChange)="onModelSelect($event.value)"
            >
              <mat-option [value]="null" disabled></mat-option>
              <mat-option
                *ngFor="let model of allModels; trackBy: trackByValue"
                [value]="model.value"
              >
                {{ model.label }}
              </mat-option>
            </mat-select>
          </div>
          <mat-error *ngIf="form.get('model')?.invalid">
            {{ form.get('model') | validateField }}
          </mat-error>

          <div class="form-group">
            <label>Approver User Template</label>
            <input
              [disabled]="(approvalUserTemplateLoading$ | async) || false"
              matInput
              class="lum-input"
              (input)="onSearchKeywordChange($event)"
              [matAutocomplete]="auto"
              [formControl]="displayApprovalUserTemplateControl"
              #autocompleteInput
            />
            <mat-autocomplete
              panelWidth="auto"
              #auto="matAutocomplete"
              (optionSelected)="onSelectOption($event)"
            >
              <ng-container
                *ngIf="
                  !(approvalUserTemplateLoading$ | async) || false;
                  else loader
                "
              >
                <mat-option
                  *ngFor="let approvalUserTemplate of approvalUserTemplates"
                  [value]="approvalUserTemplate.id"
                >
                  {{ approvalUserTemplate.label }}
                </mat-option>
              </ng-container>
              <ng-template #loader>
                <mat-option>
                  <div class="flex gap-4">
                    <mat-progress-spinner
                      class="progress-spinner mt-3"
                      diameter="24"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                    <small>Loading...</small>
                  </div>
                </mat-option>
              </ng-template>
            </mat-autocomplete>
          </div>
          <mat-error *ngIf="form.get('approvalUserTemplateId')?.invalid">
            {{ form.get('approvalUserTemplateId') | validateField }}
          </mat-error>

          <div class="form-group">
            <label>Logical Operator</label>
            <mat-select class="lum-select" formControlName="operator">
              <mat-option
                *ngFor="
                  let logicalOperator of logicalOperators;
                  trackBy: trackByValue
                "
                [value]="logicalOperator.value"
              >
                {{ logicalOperator.label }}
              </mat-option>
            </mat-select>
          </div>
          <mat-error *ngIf="form.get('operator')?.invalid">
            {{ form.get('operator') | validateField }}
          </mat-error>
        </div>
        <div class="col-6">
          <h5><strong>Approvers</strong></h5>
          <div class="form-group m-5" *ngIf="selectedUsers.length > 0">
            <mat-checkbox formControlName="enableSingleApprover">
              Enable Single Approver
              <i
                class="fas fa-question-circle text-gray-300 cursor-pointer ml-1"
                matTooltip="When enabled, once any of the approvers, approve the order, it should be marked as approved directly and does not need to wait for other approvers."
                matTooltipPosition="above"
              >
              </i>
            </mat-checkbox>
          </div>
          <table
            class="lum-table lum-table--classic striped"
            *ngIf="selectedUsers.length > 0"
          >
            <tbody>
              <ng-container *ngFor="let user of selectedUsers; trackBy: trackById">
                <tr>
                  <td>
                    <input
                      type="text"
                      class="lum-input"
                      readonly="true"
                      [value]="user.firstName + ' ' + user.lastName"
                    />
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>
            <h5><strong>Conditions</strong></h5>
            <table class="lum-table lum-table--classic striped">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th class="w-p35">Field</th>
                  <th class="w-p15">Operator</th>
                  <th class="w-p35">Value</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody
                id="approval-rule-conditions"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                formArrayName="condition"
              >
                <ng-container
                  *ngFor="
                    let item of conditionsFormArray?.controls;
                    trackBy: trackByControlValue;
                    let i = index
                  "
                >
                  <tr
                    cdkDrag
                    cdkDragLockAxis="y"
                    [formGroupName]="i"
                    id="row-approval-rule{{ i }}"
                    [lumTableAnimateRow]="item.value.sku"
                  >
                    <td>
                      <lum-ui-icon
                        cdkDragHandle
                        class="mr-2 cursor-grab"
                        icon="menu"
                        color="#36363A"
                      ></lum-ui-icon>
                    </td>
                    <td>
                      <mat-select
                        class="lum-select"
                        formControlName="field"
                        (selectionChange)="
                          updateSelectedFieldValue(i, $event.value)
                        "
                      >
                        <mat-option
                          *ngFor="
                            let selectedField of selectedFields;
                            trackBy: trackByLabel
                          "
                          [value]="selectedField.name"
                        >
                          {{ selectedField.label }}
                        </mat-option>
                      </mat-select>
                    </td>
                    <td>
                      <mat-select formControlName="operator" class="lum-select">
                        <ng-container
                          *ngIf="
                            selectedFieldValues[i]?.operators;
                            else defaultOperators
                          "
                        >
                          <mat-option
                            *ngFor="
                              let comparisonOperator of selectedFieldValues[i]
                                ?.operators;
                              trackBy: trackByLabel
                            "
                            [value]="comparisonOperator.value"
                          >
                            {{ comparisonOperator.label }}
                          </mat-option>
                        </ng-container>

                        <ng-template #defaultOperators>
                          <mat-option
                            *ngFor="
                              let comparisonOperator of comparisonOperators;
                              trackBy: trackByLabel
                            "
                            [value]="comparisonOperator.value"
                          >
                            {{ comparisonOperator.label }}
                          </mat-option>
                        </ng-template>
                      </mat-select>
                    </td>
                    <td>
                      <ng-container [ngSwitch]="selectedFieldValues[i]?.inputType">
                        <input
                          class="lum-input"
                          *ngSwitchCase="'number'"
                          type="number"
                          formControlName="value"
                        />
                        <mat-select
                          *ngSwitchCase="'select'"
                          class="lum-select"
                          formControlName="value"
                        >
                          <mat-option
                            *ngFor="
                              let option of selectedFieldValues[i]?.options;
                              trackBy: trackByLabel
                            "
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </mat-option>
                        </mat-select>
                        <ng-container *ngSwitchCase="'select2'">
                          <lum-channel-control
                            *ngIf="
                              selectedFieldValues[i]?.customComponent === 'channel'
                            "
                            formControlName="value"
                            [bindKey]="'id'"
                          ></lum-channel-control>
                        </ng-container>

                        <input
                          class="lum-input"
                          *ngSwitchDefault
                          type="text"
                          formControlName="value"
                        />
                      </ng-container>
                    </td>
                    <td class="actions">
                      <button
                        class="lum-button lum-button--small lum-button--secondary w-20"
                        mat-icon-button
                        (click)="onRemoveCondition(i)"
                      >
                        <lum-ui-icon
                          icon="minus-circle"
                          [width]="16"
                          [height]="16"
                          color="#3a47af"
                        ></lum-ui-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="mt-4">
            <button
              type="button"
              class="lum-button lum-button--secondary btn-block"
              [matMenuTriggerFor]="menu"
            >
              Add Condition(s)
            </button>
            <mat-menu
              class="lum-mat-menu"
              #menu="matMenu"
              yPosition="above"
              xPosition="before"
            >
              <button mat-menu-item (click)="onAddMultipleConditions(1)">
                Add 1 Condition
              </button>
              <button mat-menu-item (click)="onAddMultipleConditions(5)">
                Add 5 Conditions
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
          Save
          <lum-ui-icon class="ml-2-5" icon="content-save"></lum-ui-icon>
        </lum-ui-button>
      </div>
    </div>
  </form>
</ng-template>
